module.exports = __webpack_public_path__ + "img/img-2.d89b0414.webp";